import styled from 'styled-components'
import config from '../../config/env'
const foot = `${config.baseUrl}/hitcloud/home/index/footbg.png`
export const FooterWrapper = styled.footer`
    height: 285px;
    background-color: #0c1939;
    background-image:url(${foot});
    background-size: contain;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    a{
        font-size: 14px;
        color: #929292;
        display:flex;
        justify-content:center;
        align-items: center;
        margin-bottom:10px;
    }
`;